export class CookieHelper {
    public static getCookie(cname: string): string {
        const name = cname + "=";
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return "";
    }

    public static setCookie(name: string, value: string, expireDays: number, path = ""): void {
        // first answer: https://stackoverflow.com/questions/34298133/angular-2-cookies

        let expires = "";
        if (expireDays > 0) {
            const d: Date = new Date();
            d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
            expires = `expires=${d.toUTCString()}`;
        }

        const cpath: string = path ? `; path=${path}` : "";

        document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }

    public static eraseCookie(cname: string, path = ""): void {
        const cpath: string = path ? `; path=${path}` : "";
        document.cookie = `${cname}=; expires=Thu, 01 Jan 1971 00:00:01 GMT${cpath}`;
    }
}
